import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 28em;
  padding-top: 1.5em;
`
